import callApi, { METHOD_TYPE } from '../utils/callApi'
import { SIGNIN } from '../mutations'
const state = {
  login: false
}

const mutations = {
  [SIGNIN.SIGNOUT](state) { state.login = false },
  [SIGNIN.SIGNIN](state) { state.login = true }
}

const actions = {
  checkSessionId({ commit }) {
    // sessionidがnullの場合、ログインページに遷移する
    let name = 'sessionid'
    const reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)')
    let arr = document.cookie.match(reg)
    if (arr === null || arr[2] === null || arr[2] === '') {
      const domain = process.env.NODE_ENV === 'local'
        ? process.env.API_HOST + '/api/sign-in?key=localtest'
        : location.protocol + '//' + location.hostname + '/api/sign-in'
      location.href = domain
    } else {
      commit(SIGNIN.SIGNIN)
      // ローカル環境以外の場合、サブドメインを抜ける
      if (process.env.NODE_ENV !== 'local') {
        const index = location.hostname.indexOf('.console.pdq')
        if (index !== -1) {
          const upperLevelDomain = location.hostname.substring(index + 1)
          location.href = location.protocol + '//' + upperLevelDomain
        }
      }
    }
  },
  signOut({ commit }, router) {
    callApi('/sign-out', METHOD_TYPE.GET)
    .then((response) => {
      commit(SIGNIN.SIGNOUT)
      router.push('/')
    })
    .catch(e => {
      if (e.response == null) {
        alert('ログアウトに失敗しました' + '\n' + e.message)
      } else {
        alert('ログアウトに失敗しました' + '\n[' + e.message + ']' + JSON.parse(e.response.text).error.message)
      }
    })
  }
}

export default {state, actions, mutations}



// WEBPACK FOOTER //
// ./src/stores/signin.js